import React from 'react';
import { IEditorProps } from './Editor';
import { EditorCheckbox } from './EditorCheckbox';

interface INullableCheckboxEditorProps extends IEditorProps {}

/**
 * A checkbox editor that reports a "null" value for an indeterminate state.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function NullableCheckboxEditor(props: INullableCheckboxEditorProps) {
  return <EditorCheckbox {...props} nullable />;
}
